import { When } from 'react-if';
import { formatDateRange } from 'rwl-shared/dist/utils/date';
import { Body1, Body2, Subtitle2 } from 'rwl-ui';
import styled from 'styled-components6';
import { useReview } from '../../../fetchers/ReviewFetcher/ReviewFetcher';

const ReviewResponseContainer = styled.div`
    width: 90%;
    border-left: 3px solid var(--rwl-palette-gray-300);
    padding-left: var(--rwl-spacing-md);
`;

export const ReviewResponse = () => {
    const { review } = useReview();
    return (
        <When condition={review && review?.response?.message}>
            <ReviewResponseContainer>
                <Subtitle2
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    Response from owner{' '}
                    {review?.response?.postedAt && (
                        <Body2 style={{ marginLeft: 'var(--rwl-spacing-sm)' }}>
                            {formatDateRange(
                                new Date(review?.response.postedAt)
                            )}
                        </Body2>
                    )}
                </Subtitle2>
                <Body1>{review?.response?.message}</Body1>
            </ReviewResponseContainer>
        </When>
    );
};
